<template>
	<v-container>
		<v-layout>
			
			<v-card>
				<v-layout row wrap>
					<v-flex xs6 offset-xs3 offset-sm0 sm4 lg3 align-content-center>
						<v-img class="hidden-xs-only" :src="require('@/assets/Profile_1.jpg')" position="center top" alt="Steven Noyce profile photo"></v-img>
						<v-flex class="hidden-sm-and-up" ma-3>
							<v-img  :src="require('@/assets/Profile_1.jpg')" position="center top" aspect-ratio="1" style="border-radius:50%" alt="Steven Noyce profile photo"></v-img>
						</v-flex>
					</v-flex>
					
					<v-flex xs12 sm8 lg9 pa-3>
						
						<h1 class="text-uppercase display-2 font-weight-thin">
							Hi, I'm Steven
						</h1>
						<br/>
						<p>
							I'm an engineer, a researcher, and a developer.  Having just finished a PhD at Duke University, I am beginning my career at two startups spun out of my lab there.  I'm always on the lookoug for an innovative company in need of a driven research engineer.  Feel free to reach out to me on <a href="https://www.linkedin.com/in/steven-noyce/">LinkedIn</a>.
						</p>
					</v-flex>
				</v-layout>
			</v-card>
			
		</v-layout>
	</v-container>
</template>

<script>
	export default {
		data: () => ({
			//
		})
	}
</script>

